<template>
  <div class="form-group skill-formdata">
    <multiselect
      v-model="reason"
      @input="updateData"
      @remove="cleareData"
      :loading="isLoading"
      :options="reasons"
      :placeholder="placeholder"
      :clearOnSelect="false"
      :closeOnSelect="true"
      :preserveSearch="true"
      label="title"
      track-by="title"
    >
      <template slot="singleLabel" slot-scope="props">
        <div
          class="mr-1"
          style="font-size: 14px;white-space: nowrap;overflow: hidden;"
        >{{ props.option.title }}</div>
      </template>
      <template slot="option" slot-scope="props">
        <div class="mr-1" style="font-size: 14px;white-space: nowrap;overflow: hidden;">
          {{ props.option.title }}
          <p>{{ props.option.comment }}</p>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "cancel-reason",
  components: {
    Multiselect
  },
  props: ["place_holder", "value"],
  data() {
    return {
      reason: null,
      reasons: [],
      placeholder: "Select a cancel reason",
      isLoading: false
    };
  },
  created() {
    if (
      this.place_holder != "" &&
      this.place_holder != null &&
      this.place_holder != undefined
    ) {
      this.placeholder = this.place_holder;
    }
    let api_token = window.api_token;
    let self = this;
    self.isLoading = true;
    axios({
      method: "get",
      url: "/api/v1/cancel-reason/all?api_token=" + api_token
    })
      .then(function(response) {
        self.isLoading = false;
        if (response.data.ok) {
          self.reasons = response.data.data;
        }
      })
      .catch(function(err) {
        self.isLoading = false;
        self.errors = err.response.data.errors;
      });
  },
  methods: {
    updateData: function(value) {
      this.$emit("input", value.id);
    },
    cleareData: function() {
      this.$emit("input", null);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (
          this.reason == null &&
          this.value != null &&
          this.value != undefined &&
          this.value != ""
        ) {
          let self = this;
          let api_token = window.api_token;
          self.isLoading = true;
          axios({
            method: "get",
            url:
              "/api/v1/cancel-reason/" +
              self.value +
              "/show?api_token=" +
              api_token
          })
            .then(function(response) {
              self.isLoading = false;
              if (response.data.ok) {
                self.reason = response.data.data;
              }
            })
            .catch(function(err) {
              self.isLoading = false;
              self.errors = err.response.data.errors;
            });
        }
      }
    }
  }
};
</script>
